import React, { Component } from "react";
import { Table, Button } from "antd";
import { RightOutlined } from "@ant-design/icons";
import moment from "moment";
import { connect } from "react-redux";

import { JourneySearchBar } from "./search-bar/journey-search-bar";
import { JourneyDiary } from "./journey-detail/journey-diary";
import { apiJourney } from "../../../api/api-journey";
import { emitter } from "../../../common/utils/emitter";
import { CAR_STATUS } from "../../../common/utils/static-data";
import { PaymentRequest } from "./payment-request/payment-request";

const STATUS_DATA = {
  1: "Đang chờ điều xe",
  2: "Đã điều xe",
  3: "Đang diễn ra",
  4: "Đã hoàn thành",
  5: "Đã hủy",
  6: "Đang cho mượn xe",
  7: "Đang cho mượn tài",
  8: "Đang cho mượn xe và tài",
};

class JourneyTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lockTime: 0,
      dataTable: [],
      total: 0,
      totalForPaymentRequest: { over_km: 0 },
      isShowDetail: false,
      typeOption: "create_new",
      isPaymentRequest: false,
      dataChoose: null,
      journey_diarys: [],
      dateForPaymentRequest: {},
      searchFilter: {
        status_not: 1,
        branch: {
          code: null,
        },
        contract_type: {
          id: null,
        },
        customer: {
          name: null,
        },
        driver: {
          name: null,
        },
        from_datetime_gte: null,
        from_datetime_lte: null,
        vehicle: {
          number_plate: null,
          type: null,
        },
        code: null,
        status: null,
        member_customer_ids: "",
      },
    };

    this.page = 1;

    this.customerTableCustomer = [
      {
        title: "Hợp đồng",
        dataIndex: "code",
        key: "contract",
      },
      {
        title: "Thời gian hành trình",
        dataIndex: "data",
        key: "data",
        render: (data) => {
          const start = moment(data.from_date).format("DD/MM/YYYY");
          const end = moment(data.to_date).format("DD/MM/YYYY");
          return data ? (
            <span>
              {start} - {end}
            </span>
          ) : null;
        },
      },
      {
        title: "Tài xế",
        dataIndex: "driver",
        key: "driver",
        render: (item) => <div>{item ? item.name : ""}</div>,
      },
      {
        title: "Biển KS",
        dataIndex: "vehicle",
        key: "number_plate",
        className: "text-center",
        render: (item) => (
          <div style={{ minWidth: 60, textAlign: "center" }}>
            {item ? item.number_plate : ""}
          </div>
        ),
      },
      {
        title: "Thời gian gửi",
        dataIndex: "created_at",
        key: "created_at",
        render: (item) => {
          const time_unix = moment(item).format("DD/MM/YYYY");
          return item ? <span>{time_unix}</span> : null;
        },
      },
      {
        title: "Chi tiết",
        dataIndex: "data",
        key: "detail",
        render: (data) => (
          <div onClick={() => this.showDetail(data)}>
            <img
              alt=""
              className="detail-icon"
              src={require("../../../assets/icons/info-circle-solid.png")}
            />
          </div>
        ),
      },
    ];

    this.customerTable = [
      {
        title: "STT",
        dataIndex: "index",
        key: "index",
        maxWidth: 60,
      },
      {
        title: "Loại xe",
        dataIndex: "vehicle",
        key: "type",
        render: (item) => (
          <div style={{ minWidth: 60, textAlign: "left" }}>
            {item ? item.type : ""}
          </div>
        ),
      },
      {
        title: "Biển KS",
        dataIndex: "vehicle",
        key: "number_plate",
        className: "text-center",
        render: (item) => (
          <div style={{ minWidth: 60, textAlign: "center" }}>
            {item ? item.number_plate : ""}
          </div>
        ),
      },
      {
        title: "Tài xế",
        dataIndex: "driver",
        key: "driver",
        render: (item) => (
          <div style={{ minWidth: 60, textAlign: "left" }}>
            {item ? item.name : ""}
          </div>
        ),
      },
      {
        title: "Hợp đồng",
        dataIndex: "code",
        key: "contract",
        render: (code) => (
          <div style={{ minWidth: 60, textAlign: "left" }}>{code}</div>
        ),
      },
      {
        title: "Khách hàng",
        dataIndex: "customer",
        key: "customer",
        className: "column-max-250",
        render: (item) => (
          <div style={{ minWidth: 200, textAlign: "left" }}>{item.name}</div>
        ),
      },
      {
        title: "Loại hợp đồng",
        dataIndex: "contract_type",
        key: "contract_type",
        className: "text-center",
        render: (contract_type) => (
          <div style={{ minWidth: 60, textAlign: "center" }}>
            {contract_type.id === 1 ? "Có lái" : "Không lái"}{" "}
          </div>
        ),
      },
      {
        title: "Trạng thái",
        dataIndex: "status",
        key: "status",
        className: "text-center",
        render: (status) => (
          <div style={{ minWidth: 60, textAlign: "center" }}>
            {STATUS_DATA[status]}
          </div>
        ),
      },
      {
        title: "Chi tiết",
        dataIndex: "data",
        key: "detail",
        render: (data) => (
          <div style={{ minWidth: 60 }} onClick={() => this.showDetail(data)}>
            <img
              alt=""
              className="detail-icon"
              src={require("../../../assets/icons/info-circle-solid.png")}
            />
          </div>
        ),
      },
    ];
  }

  isCustomer = () => {
    return (
      this.props.auth &&
      this.props.auth.roles &&
      this.props.auth.roles.includes("Customer")
    );
  };

  getData = async (page) => {
    if (page) {
      this.page = page;
    } else {
      this.page = 1;
    }
    try {
      emitter.emit("FETCH_LOADING", true);
      const { state } = this.search;

      let searchFilter = this.state.searchFilter;

      if (state.checkSearch) {
        searchFilter = {
          status_not: 1,
          branch: {
            code: state.branch ? state.branch : null,
          },
          contract_type: {
            id: state.contract_type ? state.contract_type : null,
          },
          customer: {
            name: state.customer
              ? `%${state.customer.trim().replace(/%/gi, "\\%")}%`
              : null,
          },
          driver: {
            name: state.driver
              ? `%${state.driver.trim().replace(/%/gi, "\\%")}%`
              : null,
          },
          from_datetime_gte: state.from_datetime_gte
            ? state.from_datetime_gte
            : null,
          from_datetime_lte: state.from_datetime_lte
            ? state.from_datetime_lte
            : null,
          vehicle: {
            number_plate: state.number_plate
              ? `%${state.number_plate.trim().replace(/%/gi, "\\%")}%`
              : null,
            type: state.car_type
              ? `%${state.car_type.trim().replace(/%/gi, "\\%")}%`
              : null,
          },
          code: state.contract
            ? `%${state.contract.trim().replace(/%/gi, "\\%")}%`
            : null,
          status:
            state.status &&
            state.status !== 6 &&
            state.status !== 7 &&
            state.status !== 8
              ? state.status
              : null,
          driver_is_transferred_another: state.status
            ? state.status === 7 || state.status === 8
              ? true
              : false
            : null,
          vehicle_is_transferred_another: state.status
            ? state.status === 6 || state.status === 8
              ? true
              : false
            : null,
        };
        this.setState({ searchFilter });
      }
      const result = await apiJourney.getJourneys(searchFilter, page);

      emitter.emit("FETCH_LOADING", false);
      if (result.status === "success") {
        const dataConvert = result.data.content.map((value, index) => {
          return {
            index: index + (page - 1) * 10 + 1,
            ...value,
            data: value,
            status: this.getStatus(value),
          };
        });
        this.setState(
          { dataTable: dataConvert, total: result.data.total_elements },
          () => {}
        );
      }
    } catch (error) {
      emitter.emit("FETCH_LOADING", false);
    }
  };

  getStatus = (contract) => {
    if (
      contract.driver_is_transferred_another === false &&
      contract.vehicle_is_transferred_another === false
    ) {
      return contract.status;
    } else if (
      contract.driver_is_transferred_another === true &&
      contract.vehicle_is_transferred_another === false
    ) {
      return 7;
    } else if (
      contract.driver_is_transferred_another === false &&
      contract.vehicle_is_transferred_another === true
    ) {
      return 6;
    } else if (
      contract.driver_is_transferred_another === true &&
      contract.vehicle_is_transferred_another === true
    ) {
      return 8;
    }

    return contract.status;
  };

  componentDidMount() {
    this.getData(1);
  }

  showDetail = (data) => {
    this.handleShowDetail(true, "show_detail", data);
  };

  handleShowDetail = (status, type, data) => {
    // if (data && data.contract_type.id === 2){
    //   return;
    // }
    this.setState(
      {
        isShowDetail: status,
        typeOption: type,
        isPaymentRequest: false,
        dataChoose: data,
      },
      () => {
        const element = document.getElementById("right-layout");
        element.scrollTo(0, 0);
        if (!status) {
          this.getData(1);
        }
      }
    );
  };

  onChangePage = (page) => {
    const element = document.getElementById("right-layout");
    element.scrollTo(0, 0);
    this.getData(page);
  };

  goToPaymentRequest = (status, journey_diarys, date, total) => {
    this.setState({
      isPaymentRequest: status,
      isShowDetail: true,
      journey_diarys,
      dateForPaymentRequest: date,
      totalForPaymentRequest: total,
      member_customer_ids: !status ? "" : this.state.member_customer_ids,
    });
  };

  updateLockTime = (time) => {
    this.setState({
      lockTime: time,
    });
  };

  updateNameFilterJorney = (value) => {
    this.setState({ member_customer_ids: value });
  };

  render() {
    const {
      dataTable,
      total,
      isShowDetail,
      isPaymentRequest,
      dataChoose,
      journey_diarys,
      dateForPaymentRequest,
      totalForPaymentRequest,
      lockTime,
      member_customer_ids,
    } = this.state;
    return (
      <div className="contract-table">
        <div className="journey-title">
          <span onClick={() => this.handleShowDetail(false)}>
            {this.isCustomer()
              ? "Danh sách Hợp đồng"
              : "Danh sách tổng hợp NKHT"}{" "}
          </span>
          {isShowDetail && (
            <>
              <RightOutlined />
              <span onClick={() => this.goToPaymentRequest(false)}>
                {" "}
                Chi tiết nhật ký hành trình
              </span>
            </>
          )}
          {isPaymentRequest && (
            <>
              <RightOutlined />
              <span> Xuất Payment Request</span>
            </>
          )}
        </div>
        {!isShowDetail ? (
          <>
            <JourneySearchBar
              hiddenLock={this.isCustomer()}
              search={this.getData}
              ref={(ref) => (this.search = ref)}
              updateLockTime={this.updateLockTime}
            />
            <Table
              rowKey={(record) => record.id}
              style={{ width: "100%", marginBottom: 20 }}
              dataSource={dataTable}
              pagination={{
                total,
                pageSize: 10,
                onChange: this.onChangePage,
                current: this.page,
              }}
              //pagination={false}
              scroll={{ x: true }}
              columns={this.customerTable}
            />
          </>
        ) : !isPaymentRequest ? (
          <JourneyDiary
            isCustomer={this.isCustomer()}
            lockTime={lockTime}
            contractData={dataChoose}
            goToPaymentRequest={this.goToPaymentRequest}
            updateNameFilterJorney={this.updateNameFilterJorney}
          />
        ) : (
          <PaymentRequest
            totalForPaymentRequest={totalForPaymentRequest}
            date={dateForPaymentRequest}
            journey_diarys={journey_diarys}
            contractData={dataChoose}
            member_customer_ids={member_customer_ids}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps)(JourneyTable);
